import type { ChatMessage, RunState } from './types';

const THREAD_KEY = 'mastra-run-console.thread';
const AGENT_KEY = 'mastra-run-console.agent';
const SNAPSHOT_KEY = 'mastra-run-console.snapshot.v1';

interface Snapshot {
  threadId: string;
  messages: ChatMessage[];
}

export function loadThreadId(): string {
  const stored = localStorage.getItem(THREAD_KEY);
  if (stored) return stored;
  const created = crypto.randomUUID();
  localStorage.setItem(THREAD_KEY, created);
  return created;
}

export function saveThreadId(threadId: string): void {
  localStorage.setItem(THREAD_KEY, threadId);
}

export function loadAgentId(): string {
  return localStorage.getItem(AGENT_KEY) ?? 'lead';
}

export function saveAgentId(agentId: string): void {
  localStorage.setItem(AGENT_KEY, agentId);
}

export function loadSnapshot(threadId: string): ChatMessage[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(SNAPSHOT_KEY) ?? 'null');
    if (!value || typeof value !== 'object') return [];
    const snapshot = value as Snapshot;
    return snapshot.threadId === threadId && Array.isArray(snapshot.messages) ? snapshot.messages : [];
  } catch {
    return [];
  }
}

function persistableRun(run: RunState): RunState {
  return {
    ...run,
    eventLog: [],
  };
}

export function saveSnapshot(threadId: string, messages: ChatMessage[]): void {
  try {
    const compact = messages.slice(-60).map((message): ChatMessage => message.role === 'assistant'
      ? { ...message, run: persistableRun(message.run) }
      : message);
    localStorage.setItem(SNAPSHOT_KEY, JSON.stringify({ threadId, messages: compact } satisfies Snapshot));
  } catch {
    // Storage is an enhancement. A large telemetry run must never break chat.
  }
}

export function clearSnapshot(): void {
  localStorage.removeItem(SNAPSHOT_KEY);
}
